(() => {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $c4926bcb88dfb64a$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return n(r, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, o) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, o) : n(r)(t)(e)(u)(a)(i)(o);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, f(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function a(n, r) {
        for(var t, e = [], u = i(n, r, 0, e); u && (t = e.pop()); u = i(t.a, t.b, 0, e));
        return u;
    }
    function i(n, r, t, e) {
        if (t > 100) return e.push(f(n, r)), !0;
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        for(var a in 0 > n.$ && (n = dr(n), r = dr(r)), n)if (!i(n[a], r[a], t + 1, e)) return !1;
        return !0;
    }
    function o(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = o(n.a, r.a)) || (t = o(n.b, r.b)) ? t : o(n.c, r.c);
        for(; n.b && r.b && !(t = o(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var c = F2(function(n, r) {
        var t = o(n, r);
        return 0 > t ? hr : t ? lr : vr;
    });
    function f(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function s(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function b(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function d(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = l(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = l(n.a, r);
        return t;
    }
    var v = {
        $: 0
    };
    function l(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(l);
    function $(n) {
        for(var r = v, t = n.length; t--;)r = l(n[t], r);
        return r;
    }
    var p = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return $(e);
    }), g = Math.ceil, m = Math.floor, y = Math.round, w = Math.log, j = F2(function(n, r) {
        return r.split(n);
    }), k = F2(function(n, r) {
        return r.join(n);
    }), A = F3(function(n, r, t) {
        return t.slice(n, r);
    }), x = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), T = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), N = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), E = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return v;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return $(u);
    });
    function _(n) {
        return n + "";
    }
    function C(n) {
        return {
            $: 2,
            b: n
        };
    }
    var B = C(function(n) {
        return "number" != typeof n ? K("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? yr(n) : !isFinite(n) || n % 1 ? K("an INT", n) : yr(n);
    }), O = (C(function(n) {
        return "boolean" == typeof n ? yr(n) : K("a BOOL", n);
    }), C(function(n) {
        return "number" == typeof n ? yr(n) : K("a FLOAT", n);
    })), L = C(function(n) {
        return yr(n);
    }), q = C(function(n) {
        return "string" == typeof n ? yr(n) : n instanceof String ? yr(n + "") : K("a STRING", n);
    }), S = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function D(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), z = F2(function(n, r) {
        return D(n, [
            r
        ]);
    }), P = F3(function(n, r, t) {
        return D(n, [
            r,
            t
        ]);
    }), F = F4(function(n, r, t, e) {
        return D(n, [
            r,
            t,
            e
        ]);
    }), M = F5(function(n, r, t, e, u) {
        return D(n, [
            r,
            t,
            e,
            u
        ]);
    }), U = F2(function(n, r) {
        return Z(n, r);
    });
    function Z(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? yr(n.c) : K("null", r);
            case 3:
                return J(r) ? G(n.b, r, $) : K("a LIST", r);
            case 4:
                return J(r) ? G(n.b, r, I) : K("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return K("an OBJECT with a field named `" + t + "`", r);
                var e = Z(n.b, r[t]);
                return ft(e) ? e : $r(A2(gr, t, e.a));
            case 7:
                var u = n.e;
                return J(r) ? r.length > u ? (e = Z(n.b, r[u]), ft(e) ? e : $r(A2(mr, u, e.a))) : K("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : K("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || J(r)) return K("an OBJECT", r);
                var a = v;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = Z(n.b, r[i]), !ft(e)) return $r(A2(gr, i, e.a));
                    a = l(f(i, e.a), a);
                }
                return yr(Fr(a));
            case 9:
                for(var o = n.f, c = n.g, s = 0; c.length > s; s++){
                    if (e = Z(c[s], r), !ft(e)) return e;
                    o = o(e.a);
                }
                return yr(o);
            case 10:
                return e = Z(n.b, r), ft(e) ? Z(n.h(e.a), r) : e;
            case 11:
                for(var b = v, d = n.g; d.b; d = d.b){
                    if (e = Z(d.a, r), ft(e)) return e;
                    b = l(e.a, b);
                }
                return $r(wr(Fr(b)));
            case 1:
                return $r(A2(pr, n.a, r));
            case 0:
                return yr(n.a);
        }
    }
    function G(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = Z(n, r[a]);
            if (!ft(i)) return $r(A2(mr, a, i.a));
            u[a] = i.a;
        }
        return yr(t(u));
    }
    function J(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function I(n) {
        return A2(ct, n.length, function(r) {
            return n[r];
        });
    }
    function K(n, r) {
        return $r(A2(pr, "Expecting " + n, r));
    }
    function Y(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return Y(n.b, r.b);
            case 6:
                return n.d === r.d && Y(n.b, r.b);
            case 7:
                return n.e === r.e && Y(n.b, r.b);
            case 9:
                return n.f === r.f && W(n.g, r.g);
            case 10:
                return n.h === r.h && Y(n.b, r.b);
            case 11:
                return W(n.g, r.g);
        }
    }
    function W(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!Y(n[e], r[e])) return !1;
        return !0;
    }
    var Q = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function H(n) {
        return n;
    }
    function V(n) {
        return {
            $: 0,
            a: n
        };
    }
    function X(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var nn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), rn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), tn = 0;
    function en(n) {
        var r = {
            $: 0,
            e: tn++,
            f: n,
            g: null,
            h: []
        };
        return sn(r), r;
    }
    function un(n) {
        return X(function(r) {
            r(V(en(n)));
        });
    }
    function an(n, r) {
        n.h.push(r), sn(n);
    }
    var on = F2(function(n, r) {
        return X(function(t) {
            an(n, r), t(V(0));
        });
    }), cn = !1, fn = [];
    function sn(n) {
        if (fn.push(n), !cn) {
            for(cn = !0; n = fn.shift();)bn(n);
            cn = !1;
        }
    }
    function bn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, sn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var dn = {};
    function vn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function ln(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function o(n) {
            return A2(nn, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : a && i ? A4(e, t, o.i, o.j, n) : A3(e, t, a ? o.i : o.j, n);
                }
            });
        }
        return t.h = en(A2(nn, o, n.b));
    }
    var hn, $n = F2(function(n, r) {
        return X(function(t) {
            n.g(r), t(V(0));
        });
    }), pn = F2(function(n, r) {
        return A2(on, n.h, {
            $: 0,
            a: r
        });
    });
    function gn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function mn(n) {
        return {
            $: 2,
            m: n
        };
    }
    function yn(n, r, t) {
        var e = {};
        for(var u in wn(!0, r, e, null), wn(!1, t, e, null), n)an(n[u], {
            $: "fx",
            a: e[u] || {
                i: v,
                j: v
            }
        });
    }
    function wn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.q)n = r.p(n);
                        return n;
                    }
                    return A2(n ? dn[r].e : dn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: v,
                        j: v
                    }, n ? t.i = l(r, t.i) : t.j = l(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)wn(n, i.a, t, e);
                return;
            case 3:
                return void wn(n, r.o, t, {
                    p: r.n,
                    q: e
                });
        }
    }
    var jn = "undefined" != typeof document ? document : {};
    function kn(n, r) {
        n.appendChild(r);
    }
    function An(n) {
        return {
            $: 0,
            a: n
        };
    }
    var xn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: Bn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: Bn(t),
                e: u,
                f: n,
                b: a
            };
        });
    })(void 0);
    var Tn, Nn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), En = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), _n = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Bn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? On(i, u, a) : i[u] = a;
            } else "className" === u ? On(r, u, a) : r[u] = a;
        }
        return r;
    }
    function On(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Ln(n, r) {
        var t = n.$;
        if (5 === t) return Ln(n.k || (n.k = n.m()), r);
        if (0 === t) return jn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = Ln(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return qn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? jn.createElementNS(n.f, n.c) : jn.createElement(n.c);
        hn && "a" == n.c && i.addEventListener("click", hn(i)), qn(i, r, n.d);
        for(var o = n.e, c = 0; o.length > c; c++)kn(i, Ln(1 === t ? o[c] : o[c].b, r));
        return i;
    }
    function qn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Sn(n, u) : "a0" === e ? zn(n, r, u) : "a3" === e ? Dn(n, u) : "a4" === e ? Rn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Sn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Dn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Rn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function zn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = Pn(r, a), n.addEventListener(u, i, Tn && {
                    passive: 2 > lt(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Tn = !0;
            }
        }));
    } catch (n) {}
    function Pn(n, r) {
        function t(r) {
            var e = t.q, u = Z(e.a, r);
            if (ft(u)) {
                for(var a, i = lt(e), o = u.a, c = i ? 3 > i ? o.a : o.W : o, f = 1 == i ? o.b : 3 == i && o.cZ, s = (f && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.cU) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) c = a(c);
                    else for(var b = a.length; b--;)c = a[b](c);
                    s = s.p;
                }
                s(c, f);
            }
        }
        return t.q = r, t;
    }
    function Fn(n, r) {
        return n.$ == r.$ && Y(n.a, r.a);
    }
    function Mn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Un(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void Mn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, o = r.l, c = i.length, f = c === o.length; f && c--;)f = i[c] === o[c];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Un(n.k, r.k, s, 0), void (s.length > 0 && Mn(t, 1, e, s));
                case 4:
                    for(var b = n.j, d = r.j, v = !1, l = n.k; 4 === l.$;)v = !0, "object" != typeof b ? b = [
                        b,
                        l.j
                    ] : b.push(l.j), l = l.k;
                    for(var h = r.k; 4 === h.$;)v = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return v && b.length !== d.length ? void Mn(t, 0, e, r) : ((v ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, d) : b === d) || Mn(t, 2, e, d), void Un(l, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Mn(t, 3, e, r.a));
                case 1:
                    return void Zn(n, r, t, e, Jn);
                case 2:
                    return void Zn(n, r, t, e, In);
                case 3:
                    if (n.h !== r.h) return void Mn(t, 0, e, r);
                    var $ = Gn(n.d, r.d);
                    $ && Mn(t, 4, e, $);
                    var p = r.i(n.g, r.g);
                    return void (p && Mn(t, 5, e, p));
            }
        }
    }
    function Zn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Gn(n.d, r.d);
            a && Mn(t, 4, e, a), u(n, r, t, e);
        } else Mn(t, 0, e, r);
    }
    function Gn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Fn(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Gn(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var c in r)c in n || ((e = e || {})[c] = r[c]);
        return e;
    }
    function Jn(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, o = a.length;
        i > o ? Mn(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && Mn(t, 7, e, {
            v: i,
            e: a
        });
        for(var c = o > i ? i : o, f = 0; c > f; f++){
            var s = u[f];
            Un(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function In(n, r, t, e) {
        for(var u = [], a = {}, i = [], o = n.e, c = r.e, f = o.length, s = c.length, b = 0, d = 0, v = e; f > b && s > d;){
            var l = (T = o[b]).a, h = (N = c[d]).a, $ = T.b, p = N.b, g = void 0, m = void 0;
            if (l !== h) {
                var y = o[b + 1], w = c[d + 1];
                if (y) {
                    var j = y.a, k = y.b;
                    m = h === j;
                }
                if (w) {
                    var A = w.a, x = w.b;
                    g = l === A;
                }
                if (g && m) Un($, x, u, ++v), Yn(a, u, l, p, d, i), v += $.b || 0, Wn(a, u, l, k, ++v), v += k.b || 0, b += 2, d += 2;
                else if (g) v++, Yn(a, u, h, p, d, i), Un($, x, u, v), v += $.b || 0, b += 1, d += 2;
                else if (m) Wn(a, u, l, $, ++v), v += $.b || 0, Un(k, p, u, ++v), v += k.b || 0, b += 2, d += 1;
                else {
                    if (!y || j !== A) break;
                    Wn(a, u, l, $, ++v), Yn(a, u, h, p, d, i), v += $.b || 0, Un(k, x, u, ++v), v += k.b || 0, b += 2, d += 2;
                }
            } else Un($, p, u, ++v), v += $.b || 0, b++, d++;
        }
        for(; f > b;){
            var T;
            v++, Wn(a, u, (T = o[b]).a, $ = T.b, v), v += $.b || 0, b++;
        }
        for(; s > d;){
            var N, E = E || [];
            Yn(a, u, (N = c[d]).a, N.b, void 0, E), d++;
        }
        (u.length > 0 || i.length > 0 || E) && Mn(t, 8, e, {
            w: u,
            x: i,
            y: E
        });
    }
    var Kn = "_elmW6BL";
    function Yn(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return Un(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Yn(n, r, t + Kn, e, u, a);
    }
    function Wn(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Un(e, a.z, i, u), void Mn(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Wn(n, r, t + Kn, e, u);
        } else {
            var o = Mn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Qn(n, r, t, e) {
        Hn(n, r, t, 0, 0, r.b, e);
    }
    function Hn(n, r, t, e, u, a, i) {
        for(var o = t[e], c = o.r; c === u;){
            var f = o.$;
            if (1 === f) Qn(n, r.k, o.s, i);
            else if (8 === f) o.t = n, o.u = i, (s = o.s.w).length > 0 && Hn(n, r, s, 0, u, a, i);
            else if (9 === f) {
                o.t = n, o.u = i;
                var s, b = o.s;
                b && (b.A.s = n, (s = b.w).length > 0 && Hn(n, r, s, 0, u, a, i));
            } else o.t = n, o.u = i;
            if (!(o = t[++e]) || (c = o.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return Hn(n, v, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var l = r.e, h = n.childNodes, $ = 0; l.length > $; $++){
            u++;
            var p = 1 === d ? l[$] : l[$].b, g = u + (p.b || 0);
            if (!(u > c || c > g || (o = t[e = Hn(h[$], p, t, e, u, g, i)]) && (c = o.r) <= a)) return e;
            u = g;
        }
        return e;
    }
    function Vn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Xn(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Xn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Ln(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return qn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Vn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, i = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Ln(a[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Vn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = jn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                kn(t, 2 === u.c ? u.s : Ln(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Vn(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, c = 2 === o.c ? o.s : Ln(o.z, r.u);
                        n.insertBefore(c, n.childNodes[i.r]);
                    }
                    return e && kn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function nr(n) {
        if (3 === n.nodeType) return An(n.textContent);
        if (1 !== n.nodeType) return An("");
        for(var r = v, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = l(A2(Cn, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = v, o = n.childNodes;
        for(e = o.length; e--;)i = l(nr(o[e]), i);
        return A3(xn, a, r, i);
    }
    var rr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, i) {
            var o = A2(U, n, r ? r.flags : void 0);
            ft(o) || u(2);
            var c = {}, f = (o = t(o.a)).a, s = i(d, f), b = function(n, r) {
                var t;
                for(var e in dn){
                    var u = dn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = ln(u, r);
                }
                return t;
            }(c, d);
            function d(n, r) {
                s(f = (o = A2(e, n, f)).a, r), yn(c, o.b, a(f));
            }
            return yn(c, o.b, a(f)), b ? {
                ports: b
            } : {};
        }(r, e, n.eG, n.fd, n.e8, function(r, t) {
            var u = n.fe, a = e.node, i = nr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (er(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && er(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Un(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Qn(n, r, t, e), Vn(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), tr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, er = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    var ur = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, ar = "undefined" != typeof document ? document : ur, ir = "undefined" != typeof window ? window : ur, or = F3(function(n, r, t) {
        return un(X(function() {
            function e(n) {
                en(t(n));
            }
            return n.addEventListener(r, e, Tn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), cr = F2(function(n, r) {
        var t = Z(n, r);
        return ft(t) ? jr(t.a) : kr;
    });
    var fr = F2(function(n, r) {
        return function(n, r) {
            return X(function(t) {
                er(function() {
                    var e = document.getElementById(n);
                    t(e ? V(r(e)) : {
                        $: 1,
                        a: $t(n)
                    });
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), sr = h, br = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(br, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), dr = function(n) {
        return A3(br, F3(function(n, r, t) {
            return A2(sr, f(n, r), t);
        }), v, n);
    }, vr = 1, lr = 2, hr = 0, $r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), gr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), yr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kr = {
        $: 1
    }, Ar = x, xr = Q, Tr = _, Nr = F2(function(n, r) {
        return A2(k, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), Er = F2(function(n, r) {
        return $(A2(j, n, r));
    }), _r = function(n) {
        return A2(Nr, "\n    ", A2(Er, "\n", n));
    }, Cr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), Br = function(n) {
        return A3(Cr, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Or = p, Lr = F3(function(n, r, t) {
        for(;;){
            if (o(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(sr, r, t);
            n = e, r = u, t = a;
        }
    }), qr = F2(function(n, r) {
        return A3(Lr, n, r, v);
    }), Sr = F2(function(n, r) {
        return A3(Or, n, A2(qr, 0, Br(r) - 1), r);
    }), Dr = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Rr = function(n) {
        var r = Dr(n);
        return r >= 97 && 122 >= r;
    }, zr = function(n) {
        var r = Dr(n);
        return 90 >= r && r >= 65;
    }, Pr = function(n) {
        return Rr(n) || zr(n) || function(n) {
            var r = Dr(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Fr = function(n) {
        return A3(Cr, sr, v, n);
    }, Mr = F2(function(n, r) {
        return "\n\n(" + Tr(n + 1) + ") " + _r(Ur(r));
    }), Ur = function(n) {
        return A2(Zr, n, v);
    }, Zr = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n, r, e = (r = (n = t).charCodeAt(0)) ? jr(55296 > r || r > 56319 ? f(n[0], n.slice(1)) : f(n[0] + n[1], n.slice(2))) : kr;
                    if (1 === e.$) return !1;
                    var u, a = e.a, i = a.b;
                    return (Rr(u = a.a) || zr(u)) && A2(Ar, Pr, i);
                }();
                n = e, r = A2(sr, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + Tr(n.a) + "]";
                n = e, r = A2(sr, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var o = (r.b ? "The Json.Decode.oneOf at json" + A2(Nr, "", Fr(r)) : "Json.Decode.oneOf") + " failed in the following " + Tr(Br(i)) + " ways:";
                        return A2(Nr, "\n\n", A2(sr, o, A2(Sr, Mr, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(Nr, "", Fr(r)) : "!");
            default:
                var c = n.a, s = n.b;
                return (o = r.b ? "Problem with the value at json" + A2(Nr, "", Fr(r)) + ":\n\n    " : "Problem with the given value:\n\n") + _r(A2(xr, 4, s)) + "\n\n" + c;
        }
    }), Gr = 32, Jr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ir = [], Kr = g, Yr = F2(function(n, r) {
        return w(r) / w(n);
    }), Wr = function(n) {
        return n;
    }, Qr = Kr(A2(Yr, 2, Gr)), Hr = A4(Jr, 0, Qr, Ir, Ir), Vr = t, Xr = m, nt = function(n) {
        return n.length;
    }, rt = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), tt = e, et = F2(function(n, r) {
        for(;;){
            var t = A2(tt, Gr, n), e = t.b, u = A2(sr, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Fr(u);
            n = e, r = u;
        }
    }), ut = function(n) {
        return n.a;
    }, at = F2(function(n, r) {
        for(;;){
            var t = Kr(r / Gr);
            if (1 === t) return A2(tt, Gr, n).a;
            n = A2(et, n, v), r = t;
        }
    }), it = F2(function(n, r) {
        if (r.g) {
            var t = r.g * Gr, e = Xr(A2(Yr, Gr, t - 1)), u = n ? Fr(r.j) : r.j, a = A2(at, u, r.g);
            return A4(Jr, nt(r.i) + t, A2(rt, 5, e * Qr), a, r.i);
        }
        return A4(Jr, nt(r.i), Qr, Ir, r.i);
    }), ot = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(it, !1, {
                j: e,
                g: t / Gr | 0,
                i: u
            });
            var a = {
                $: 1,
                a: A3(Vr, Gr, r, n)
            };
            r -= Gr, e = A2(sr, a, e);
        }
    }), ct = F2(function(n, r) {
        if (n > 0) {
            var t = n % Gr;
            return A5(ot, r, n - t - Gr, n, v, A3(Vr, t, n - t, r));
        }
        return Hr;
    }), ft = function(n) {
        return !n.$;
    }, st = R, bt = z, dt = P, vt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ht = function(n) {
        return n;
    }, $t = ht, pt = F6(function(n, r, t, e, u, a) {
        return {
            dl: a,
            dp: r,
            e$: e,
            dK: t,
            dO: n,
            dP: u
        };
    }), gt = T, mt = function(n) {
        return n.length;
    }, yt = A, wt = F2(function(n, r) {
        return 1 > n ? r : A3(yt, n, mt(r), r);
    }), jt = E, kt = function(n) {
        return "" === n;
    }, At = F2(function(n, r) {
        return 1 > n ? "" : A3(yt, 0, n, r);
    }), xt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return kr;
            r = 10 * r + a - 48;
        }
        return u == e ? kr : jr(45 == t ? -r : r);
    }, Tt = F5(function(n, r, t, e, u) {
        if (kt(u) || A2(gt, "@", u)) return kr;
        var a = A2(jt, ":", u);
        if (a.b) {
            if (a.b.b) return kr;
            var i = a.a, o = xt(A2(wt, i + 1, u));
            if (1 === o.$) return kr;
            var c = o;
            return jr(A6(pt, n, A2(At, i, u), c, r, t, e));
        }
        return jr(A6(pt, n, u, kr, r, t, e));
    }), Nt = F4(function(n, r, t, e) {
        if (kt(e)) return kr;
        var u = A2(jt, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(Tt, n, A2(wt, a, e), r, t, A2(At, a, e));
        }
        return A5(Tt, n, "/", r, t, e);
    }), Et = F3(function(n, r, t) {
        if (kt(t)) return kr;
        var e = A2(jt, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Nt, n, jr(A2(wt, u + 1, t)), r, A2(At, u, t));
        }
        return A4(Nt, n, kr, r, t);
    }), _t = F2(function(n, r) {
        if (kt(r)) return kr;
        var t = A2(jt, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(Et, n, jr(A2(wt, e + 1, r)), A2(At, e, r));
        }
        return A3(Et, n, kr, r);
    }), Ct = N, Bt = V, Ot = Bt(0), Lt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var c = o.a, f = o.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, c, A2(n, f.a, t > 500 ? A3(Cr, n, r, Fr(s)) : A4(Lt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, c, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), qt = F3(function(n, r, t) {
        return A4(Lt, n, r, 0, t);
    }), St = F2(function(n, r) {
        return A3(qt, F2(function(r, t) {
            return A2(sr, n(r), t);
        }), v, r);
    }), Dt = nn, Rt = F2(function(n, r) {
        return A2(Dt, function(r) {
            return Bt(n(r));
        }, r);
    }), zt = F3(function(n, r, t) {
        return A2(Dt, function(r) {
            return A2(Dt, function(t) {
                return Bt(A2(n, r, t));
            }, t);
        }, r);
    }), Pt = function(n) {
        return A3(qt, zt(sr), Bt(v), n);
    }, Ft = $n, Mt = F2(function(n, r) {
        var t = r;
        return un(A2(Dt, Ft(n), t));
    });
    dn.Task = vn(Ot, F3(function(n, r) {
        return A2(Rt, function() {
            return 0;
        }, Pt(A2(St, Mt(n), r)));
    }), F3(function() {
        return Bt(0);
    }), F2(function(n, r) {
        return A2(Rt, n, r);
    }));
    var Ut = gn("Task"), Zt = rr, Gt = S, Jt = F3(function(n, r, t) {
        return {
            q: r,
            t: n,
            cw: t
        };
    }), It = F2(function(n, r) {
        return {
            aO: r,
            dA: n
        };
    }), Kt = F2(function(n, r) {
        return r.b ? A3(qt, sr, r, n) : n;
    }), Yt = function(n) {
        return A3(qt, Kt, v, n);
    }, Wt = F4(function(n, r, t, e) {
        return {
            ei: r,
            ej: t,
            ep: n,
            eq: e
        };
    }), Qt = F2(function(n, r) {
        return {
            dB: n,
            e5: r
        };
    }), Ht = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vt = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Xt = B, ne = q, re = A2(st, function(n) {
        return Br(n) ? vt(n) : Ht("There must be at least one role in your config.");
    }, Vt(A3(dt, F2(function(n, r) {
        return {
            ed: r,
            dB: n
        };
    }), A2(Gt, "name", ne), A2(bt, Wr, A2(Gt, "baseSalary", Xt))))), te = A2(st, function(n) {
        return Br(n) ? vt(n) : Ht("There must be at least one career in your config.");
    }, Vt(A3(dt, Qt, A2(Gt, "name", ne), A2(Gt, "roles", re)))), ee = O, ue = A2(st, function(n) {
        return Br(n) ? vt(n) : Ht("There must be at least one country in your config.");
    }, Vt(A3(dt, F2(function(n, r) {
        return {
            en: r,
            dB: n
        };
    }), A2(Gt, "name", ne), A2(Gt, "compressed_cost_of_living", ee)))), ae = M, ie = A5(ae, Wt, A2(Gt, "countries", ue), A2(Gt, "careers", te), A2(Gt, "careers_updated", ne), A2(Gt, "countries_updated", ne)), oe = U, ce = F2(function(n, r) {
        return r.$ ? n(r.a) : r.a;
    }), fe = F2(function(n, r) {
        return r.$ ? $r(n) : yr(r.a);
    }), se = function(n) {
        return n.b ? jr(n.a) : kr;
    }, be = {
        $: -2
    }, de = be, ve = de, le = F4(function(n, r, t, e) {
        return {
            av: e,
            ag: r,
            ak: n,
            aG: t
        };
    }), he = {
        aW: A4(le, 0, 0, 0, 0),
        D: 2,
        cj: A4(le, 0, 0, 0, 0)
    }, $e = c, pe = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return kr;
            var t = r.c, e = r.d, u = r.e;
            switch(A2($e, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return jr(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), ge = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), me = F2(function(n, r) {
        return function(t) {
            return r(A2(ge, v, A2(pe, n, t)));
        };
    }), ye = F2(function(n, r) {
        return A3(qt, F2(function(r, t) {
            return n(r) ? A2(sr, r, t) : t;
        }), v, r);
    }), we = F2(function(n, r) {
        return se(A2(ye, function(r) {
            return a(r.dB, n);
        }, r));
    }), je = F2(function(n, r) {
        return r.$ ? $r(r.a) : yr(n(r.a));
    }), ke = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return function(r) {
            return A3(n, u(r), a(r), i(r));
        };
    }), Ae = mn(v), xe = F5(function(n, r, t, e, u) {
        return {
            ae: e,
            ai: t,
            _: r,
            Q: u,
            am: n
        };
    }), Te = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(sr, n.a, Te(n.b)) : v;
    }, Ne = F2(function(n, r) {
        return jr(1 === r.$ ? $([
            n
        ]) : A2(sr, n, r.a));
    }), Ee = function(n) {
        try {
            return jr(decodeURIComponent(n));
        } catch (n) {
            return kr;
        }
    }, _e = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Ce = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(_e, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(_e, 0, e.b, e.c, A5(_e, 1, a.b, a.c, a.d, a.e), A5(_e, 1, r, t, i, u));
        }
        var i, o = u.b, c = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(_e, n, o, c, A5(_e, 0, r, t, e, f), s) : A5(_e, 0, r, t, A5(_e, 1, e.b, e.c, e.d, i = e.e), A5(_e, 1, o, c, f, s));
    }), Be = F3(function(n, r, t) {
        if (-2 === t.$) return A5(_e, 0, n, r, be, be);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2($e, n, u)){
            case 0:
                return A5(Ce, e, u, a, A3(Be, n, r, i), o);
            case 1:
                return A5(_e, e, u, r, i, o);
            default:
                return A5(Ce, e, u, a, i, A3(Be, n, r, o));
        }
    }), Oe = F3(function(n, r, t) {
        var e = A3(Be, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(_e, 1, e.b, e.c, e.d, e.e);
    }), Le = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(_e, 1, n.b, n.c, A5(_e, 0, r.b, r.c, r.d, r.e), A5(_e, 0, i, o, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, o = a.c, c = (e = a.d).d, f = e.e, s = a.e;
            return A5(_e, 0, e.b, e.c, A5(_e, 1, n.b, n.c, A5(_e, 0, u.b, u.c, u.d, u.e), c), A5(_e, 1, i, o, f, s));
        }
        return n;
    }, qe = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, d = t.e, A5(_e, 1, e = n.b, u = n.c, A5(_e, 0, r.b, r.c, r.d, o = r.e), A5(_e, 0, f, s, b, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, o = a.e, c = n.e, f = c.b, s = c.c, b = c.d, d = c.e;
            return A5(_e, 0, a.b, a.c, A5(_e, 1, i.b, i.c, i.d, i.e), A5(_e, 1, e, u, o, A5(_e, 0, f, s, b, d)));
        }
        return n;
    }, Se = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return qe(r);
                        break n;
                    }
                    return qe(r);
                }
                break n;
            }
            return r;
        }
        return A5(_e, t, a.b, a.c, a.d, A5(_e, 0, e, u, a.e, i));
    }), De = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = Le(n);
                    if (-1 === o.$) {
                        var c = o.e;
                        return A5(Ce, o.a, o.b, o.c, De(o.d), c);
                    }
                    return be;
                }
                return A5(_e, r, t, e, De(u), i);
            }
            return A5(_e, r, t, e, De(u), i);
        }
        return be;
    }, Re = F2(function(n, r) {
        if (-2 === r.$) return be;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > o(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var f = Le(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(Ce, f.a, f.b, f.c, A2(Re, n, f.d), s);
                    }
                    return be;
                }
                return A5(_e, t, e, u, A2(Re, n, a), i);
            }
            return A5(_e, t, e, u, A2(Re, n, a), i);
        }
        return A2(ze, n, A7(Se, n, r, t, e, u, a, i));
    }), ze = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, i = r.d, o = r.e;
            if (a(n, e)) {
                var c = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(o);
                return -1 === c.$ ? A5(Ce, t, c.b, c.c, i, De(o)) : be;
            }
            return A5(Ce, t, e, u, i, A2(Re, n, o));
        }
        return be;
    }), Pe = F2(function(n, r) {
        var t = A2(Re, n, r);
        return -1 !== t.$ || t.a ? t : A5(_e, 1, t.b, t.c, t.d, t.e);
    }), Fe = F3(function(n, r, t) {
        var e = r(A2(pe, n, t));
        return e.$ ? A2(Pe, n, t) : A3(Oe, n, e.a, t);
    }), Me = F2(function(n, r) {
        var t = A2(Er, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = Ee(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = Ee(e);
            return 1 === i.$ ? r : A3(Fe, a, Ne(i.a), r);
        }
        return r;
    }), Ue = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r._;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return jr(r.Q);
                    }
                    return jr(r.Q);
                }
                return kr;
            }
        }(n(A5(xe, v, function(n) {
            var r = A2(Er, "/", n);
            return Te(r.b && "" === r.a ? r.b : r);
        }(r.e$), 1 === (t = r.dP).$ ? de : A3(qt, Me, de, A2(Er, "&", t.a)), r.dl, ht)));
    }), Ze = F2(function(n, r) {
        return Yt(A2(St, n, r));
    }), Ge = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Ze, e, t(n));
        };
    }), Je = F2(function(n, r) {
        return A2(Ge, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.ai;
                return $([
                    A5(xe, n.am, n._, t, n.ae, (0, n.Q)(r(t)))
                ]);
            };
        }(r));
    }), Ie = function(n) {
        return A2(me, n, function(n) {
            return n.b && !n.b.b ? jr(n.a) : kr;
        });
    }, Ke = function(n) {
        return $([
            n
        ]);
    }, Ye = A2(qt, F2(function(n, r) {
        return 1 === n.$ ? r : A2(sr, n.a, r);
    }), v), We = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Qe = function(n) {
        return {
            $: 1,
            a: n
        };
    }, He = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ve = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xe = mn, nu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), ru = F2(function(n, r) {
        if (-2 === r.$) return be;
        var t = r.b, e = r.d, u = r.e;
        return A5(_e, r.a, t, A2(n, t, r.c), A2(ru, n, e), A2(ru, n, u));
    }), tu = F2(function(n, r) {
        return A2(nu, function(r) {
            return a(r, n);
        }, r);
    }), eu = Xe(v), uu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, au = F3(function(n, r, t) {
        return {
            cQ: t,
            dR: r,
            d_: n
        };
    }), iu = Bt(A3(au, v, kr, 0)), ou = function(n) {
        return X(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(V(0));
        });
    }, cu = X(function(n) {
        n(V(Date.now()));
    }), fu = X(function(n) {
        var r = er(function() {
            n(V(Date.now()));
        });
        return function() {
            tr(r);
        };
    }), su = pn, bu = un, du = F3(function(n, r, t) {
        var e = t.cQ, u = t.dR, a = f(u, r);
        return 1 === a.a.$ ? a.b.b ? A2(Dt, function(n) {
            return A2(Dt, function(t) {
                return Bt(A3(au, r, jr(n), t));
            }, cu);
        }, bu(A2(Dt, su(n), fu))) : iu : a.b.b ? Bt(A3(au, r, u, e)) : A2(Dt, function() {
            return iu;
        }, ou(a.a.a));
    }), vu = ht, lu = F3(function(n, r, t) {
        var e = t.cQ, u = t.d_, a = function(t) {
            return A2(Ft, n, (0, t.a)(t.$ ? r - e : vu(r)));
        };
        return A2(Dt, function(n) {
            return A2(Dt, function() {
                return Bt(A3(au, u, jr(n), r));
            }, Pt(A2(St, a, u)));
        }, bu(A2(Dt, su(n), fu)));
    }), hu = F3(function(n, r, t) {
        return n(r(t));
    });
    dn["Browser.AnimationManager"] = vn(iu, du, lu, 0, F2(function(n, r) {
        return r.$ ? {
            $: 1,
            a: A2(hu, n, r.a)
        } : uu(A2(hu, n, r.a));
    }));
    var $u = gn("Browser.AnimationManager"), pu = function(n) {
        return $u(uu(n));
    }, gu = F2(function(n, r) {
        var t = n, e = A2(ru, F2(function(n, r) {
            switch(r.n){
                case 1:
                    return b(r, {
                        n: 3
                    });
                case 2:
                    return b(r, {
                        n: 0
                    });
                default:
                    return r;
            }
        }), t);
        return A2(nu, function(n) {
            return A2(tu, n.b.n, $([
                1,
                2
            ]));
        }, dr(t)) ? pu(function() {
            return r(e);
        }) : eu;
    }), mu = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), yu = F2(function(n, r) {
        return {
            dJ: r,
            d_: n
        };
    }), wu = Bt(A2(yu, v, de)), ju = function(n) {
        return f(d(n.a ? "w_" : "d_", n.b), n);
    }, ku = function(n) {
        return A3(Cr, F2(function(n, r) {
            return A3(Oe, n.a, n.b, r);
        }), de, n);
    }, Au = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(Au, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), xu = F6(function(n, r, t, e, u, a) {
        var i = A3(Au, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var s = i.a, b = s.a, d = s.b, v = i.b;
                    if (0 > o(b, e)) {
                        a = f(v, A3(n, b, d, c));
                        continue n;
                    }
                    return o(b, e) > 0 ? f(i, A3(t, e, u, c)) : f(v, A4(r, b, d, u, c));
                }
                return f(i, A3(t, e, u, c));
            }
        }), f(dr(e), a), u), c = i.a, s = i.b;
        return A3(Cr, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, c);
    }), Tu = F2(function(n, r) {
        return {
            dk: r,
            dv: n
        };
    }), Nu = F3(function(n, r, t) {
        return A2(Rt, function(n) {
            return f(r, n);
        }, A3(or, t.a ? ir : ar, t.b, function(t) {
            return A2(su, n, A2(Tu, r, t));
        }));
    }), Eu = F2(function(n, r) {
        return A3(Au, Oe, r, n);
    }), _u = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return s(e.a, e.b, A2(sr, A3(Nu, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return s(A2(sr, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return s(e.a, A3(Oe, n, r, e.b), u);
        }), i = A2(St, ju, r), o = A6(xu, u, a, e, t.dJ, ku(i), s(v, de, v)), c = o.b, f = o.c;
        return A2(Dt, function(n) {
            return Bt(A2(yu, i, A2(Eu, c, ku(n))));
        }, A2(Dt, function() {
            return Pt(f);
        }, Pt(A2(St, ou, o.a))));
    }), Cu = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(sr, e.a, t);
    }), Bu = F2(function(n, r) {
        return A3(qt, Cu(n), v, r);
    }), Ou = F3(function(n, r, t) {
        var e = r.dk, u = r.dv, i = A2(Bu, function(n) {
            var r = n.b.c;
            return a(n.a, u) ? A2(cr, r, e) : kr;
        }, t.d_);
        return A2(Dt, function() {
            return Bt(t);
        }, Pt(A2(St, Ft(n), i)));
    });
    dn["Browser.Events"] = vn(wu, _u, Ou, 0, F2(function(n, r) {
        return A3(mu, r.a, r.b, A2(bt, n, r.c));
    }));
    var Lu, qu, Su = gn("Browser.Events"), Du = F3(function(n, r, t) {
        return Su(A3(mu, n, r, t));
    }), Ru = A2(Du, 0, "click"), zu = F2(function(n, r) {
        return b(r, {
            D: n
        });
    }), Pu = F2(function(n, r) {
        switch(n.D){
            case 0:
                return pu(function() {
                    return r(A2(zu, 1, n));
                });
            case 1:
                return Ru(vt(r(A2(zu, 2, n))));
            default:
                return eu;
        }
    }), Fu = {
        $: 13
    }, Mu = rn, Uu = F2(function(n, r) {
        return Ut(A2(Mu, A2(hu, A2(hu, Bt, n), $r), A2(Dt, A2(hu, A2(hu, Bt, n), yr), r)));
    }), Zu = fr("focus"), Gu = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Ju = F3(function(n, r, t) {
        var e = Br(r);
        switch(n){
            case "ArrowDown":
                return f(0 > o(t, e - 1) ? t + 1 : t, kr);
            case "ArrowUp":
                return f(t > 0 ? t - 1 : t, kr);
            case "Enter":
                return f(t, se(A2(Gu, t, r)));
            default:
                return f(t, kr);
        }
    }), Iu = function(n) {
        return n.toLowerCase();
    }, Ku = F2(function(n, r) {
        switch(n.$){
            case 0:
                return f(b(r, {
                    Y: n.a,
                    M: 0
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("role-search-input")));
            case 1:
                return f(b(r, {
                    F: n.a,
                    K: 0
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("country-search-input")));
            case 2:
                return f(b(r, {
                    O: n.a,
                    P: 0
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("tenure-search-input")));
            case 3:
                return f(b(r, {
                    F: he,
                    t: jr(n.a),
                    Y: he,
                    C: "",
                    y: A2(ye, function(n) {
                        return !!n.aO;
                    }, r.y)
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("country-search-input")));
            case 4:
                return f(b(r, {
                    q: jr(n.a),
                    F: he,
                    z: "",
                    O: he,
                    y: A2(ye, function(n) {
                        return 1 !== n.aO;
                    }, r.y)
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("tenure-search-input")));
            case 5:
                return f(b(r, {
                    N: n.a,
                    E: ""
                }), Ae);
            case 6:
                return f(b(r, {
                    ao: n.a
                }), Ae);
            case 7:
                return f(b(r, {
                    z: n.a,
                    K: 0
                }), Ae);
            case 8:
                return f(b(r, {
                    C: n.a,
                    M: 0
                }), Ae);
            case 9:
                return f(b(r, {
                    E: n.a,
                    P: 0
                }), Ae);
            case 10:
                var t = n.a, e = Yt(A2(St, function(n) {
                    return n.e5;
                }, r.ei)), u = kt(r.C) ? e : A2(ye, function(n) {
                    return A2(gt, Iu(r.C), Iu(n.dB));
                }, e);
                return (h = (l = A3(Ju, t, u, r.M)).b).$ ? f(b(r, {
                    M: l.a
                }), Ae) : f(b(r, {
                    F: he,
                    t: jr(h.a),
                    Y: he,
                    C: "",
                    M: 0,
                    y: A2(ye, function(n) {
                        return !!n.aO;
                    }, r.y)
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("country-search-input")));
            case 11:
                t = n.a;
                var a = kt(r.z) ? r.ep : A2(ye, function(n) {
                    return A2(gt, Iu(r.z), Iu(n.dB));
                }, r.ep);
                return (v = (d = A3(Ju, t, a, r.K)).b).$ ? f(b(r, {
                    K: d.a
                }), Ae) : f(b(r, {
                    q: jr(v.a),
                    F: he,
                    z: "",
                    K: 0,
                    O: he,
                    y: A2(ye, function(n) {
                        return 1 !== n.aO;
                    }, r.y)
                }), A2(Uu, function() {
                    return Fu;
                }, Zu("tenure-search-input")));
            case 12:
                t = n.a;
                var i = $([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    15,
                    20
                ]), o = kt(r.E) ? i : A2(ye, function(n) {
                    return A2(gt, r.E, Tr(n));
                }, i);
                return f(b(r, (s = (c = A3(Ju, t, o, r.P)).b).$ ? {
                    P: c.a
                } : {
                    N: s.a,
                    O: he,
                    E: "",
                    P: 0
                }), Ae);
            default:
                return f(r, Ae);
        }
        var c, s, d, v, l, h;
    }), Yu = L, Wu = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, {
                    R: jr(n.a)
                });
            case 1:
                return b(r, {
                    T: jr(n.a)
                });
            case 2:
                return b(r, {
                    Z: jr(n.a)
                });
            default:
                return b(r, {
                    bj: d(r.bj, n.a)
                });
        }
    }), Qu = H, Hu = F2(function(n, r) {
        return A2(_n, n, Qu(r));
    }), Vu = Hu("className"), Xu = {
        R: kr,
        bj: v,
        T: kr,
        Z: kr
    }, na = F2(function(n, r) {
        return r.$ ? kr : jr(n(r.a));
    }), ra = function(n) {
        switch(n){
            case 0:
                return kr;
            case 1:
                return jr("sm");
            case 2:
                return jr("md");
            case 3:
                return jr("lg");
            default:
                return jr("xl");
        }
    }, ta = function(n) {
        var r = n.dg;
        return Vu("text" + (A2(ge, "-", A2(na, function(n) {
            return "-" + n + "-";
        }, ra(n.aj))) + function(n) {
            switch(n){
                case 1:
                    return "center";
                case 0:
                    return "left";
                default:
                    return "right";
            }
        }(r)));
    }, ea = F2(function(n, r) {
        return Vu(n + "-" + function() {
            switch(r){
                case 0:
                    return "primary";
                case 1:
                    return "secondary";
                case 2:
                    return "success";
                case 3:
                    return "info";
                case 4:
                    return "warning";
                case 5:
                    return "danger";
                case 6:
                    return "light";
                default:
                    return "dark";
            }
        }());
    }), ua = function(n) {
        return 1 === n.$ ? Vu("text-white") : A2(ea, "text", n.a);
    }, aa = xn("div"), ia = F2(function(n, r) {
        var t;
        return t = A2(aa, function(n) {
            var r, t, e, u = A3(Cr, Wu, Xu, n);
            return d($([
                Vu("card-body")
            ]), d((e = u.R).$ ? v : $([
                ta(e.a)
            ]), d((t = u.T).$ ? v : $([
                A2(ea, "bg", t.a)
            ]), d((r = u.Z).$ ? v : $([
                ua(r.a)
            ]), u.bj))));
        }(n), A2(St, function(n) {
            return n;
        }, r)), {
            $: 0,
            a: t
        };
    }), oa = ia, ca = F2(function(n, r) {
        return b(r, {
            bm: n
        });
    }), fa = F3(function(n, r, t) {
        return {
            bj: r,
            bo: v,
            bp: v,
            di: n,
            d3: t
        };
    })(aa), sa = {
        $: 1,
        a: {
            $: 1,
            a: 6
        }
    }, ba = F2(function(n, r) {
        return b(r, {
            bp: d(n, r.bp)
        });
    }), da = xn("span"), va = xn("p"), la = F2(function(n, r) {
        return A2(va, d($([
            Vu("card-text")
        ]), n), r);
    }), ha = An, $a = F2(function(n, r) {
        return {
            bj: n,
            em: r
        };
    }), pa = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, {
                    R: jr(n.a)
                });
            case 1:
                return b(r, {
                    T: jr(n.a)
                });
            case 2:
                return b(r, {
                    Z: jr(n.a)
                });
            default:
                return b(r, {
                    bj: d(r.bj, n.a)
                });
        }
    }), ga = {
        R: kr,
        bj: v,
        T: kr,
        Z: kr
    }, ma = _, ya = F2(function(n, r) {
        return A2(ge, {
            av: kr,
            n: 0
        }, A2(pe, n, r));
    }), wa = En, ja = F2(function(n, r) {
        return d($([
            A2(wa, "position", "relative"),
            A2(wa, "height", r),
            A2(wa, "overflow", "hidden")
        ]), n ? $([
            A2(wa, "-webkit-transition-timing-function", "ease"),
            A2(wa, "-o-transition-timing-function", "ease"),
            A2(wa, "transition-timing-function", "ease"),
            A2(wa, "-webkit-transition-duration", "0.35s"),
            A2(wa, "-o-transition-duration", "0.35s"),
            A2(wa, "transition-duration", "0.35s"),
            A2(wa, "-webkit-transition-property", "height"),
            A2(wa, "-o-transition-property", "height"),
            A2(wa, "transition-property", "height")
        ]) : v);
    }), ka = F3(function(n, r, t) {
        var e = t.eD, u = ja(r.an), a = A2(ya, e, n), i = A2(ge, "0", A2(na, function(n) {
            return ma(n) + "px";
        }, a.av));
        switch(a.n){
            case 0:
            case 1:
                return u("0px");
            case 2:
                return u(i);
            default:
                return u(a.av.$ ? "100%" : i);
        }
    }), Aa = Hu("id"), xa = function(n) {
        return A2(St, function(n) {
            return n.a;
        }, n);
    }, Ta = F3(function(n, r, t) {
        var e = t.ee;
        return A2(aa, d($([
            Aa(t.eD)
        ]), A3(ka, n, r, t)), $([
            A2(aa, v, xa(e))
        ]));
    }), Na = xn("button"), Ea = F2(function(n, r) {
        var t = f(n, r);
        if (t.a) switch(t.b){
            case 0:
                return 1;
            case 1:
                return 3;
            case 3:
                return 2;
            default:
                return 0;
        }
        else switch(t.b){
            case 0:
            default:
                return 3;
            case 3:
                return 0;
        }
    }), _a = F4(function(n, r, t, e) {
        var u = n, i = e.eD, o = A3(Oe, i, A2(ge, {
            av: kr,
            n: 0
        }, A2(pe, i, u)), u);
        return A2(st, function(n) {
            var t;
            return vt({
                W: r.c2((t = n, A2(ru, F2(function(n, e) {
                    return a(n, i) ? {
                        av: jr(t),
                        n: A2(Ea, r.an, e.n)
                    } : 3 === e.n && r.an && r.aZ ? b(e, {
                        n: 2
                    }) : 3 === e.n && !r.an && r.aZ ? b(e, {
                        n: 0
                    }) : e;
                }), o))),
                cU: !0,
                cZ: !0
            });
        }, t);
    }), Ca = Nn, Ba = F2(function(n, r) {
        return A2(Ca, n, {
            $: 3,
            a: r
        });
    }), Oa = F2(function(n, r) {
        return A3(qt, Gt, r, n);
    }), La = function(n) {
        return Oa($([
            "childNodes",
            Tr(n)
        ]));
    }, qa = function(n) {
        return A2(Gt, "nextSibling", n);
    }, Sa = A2(Gt, "offsetHeight", ee), Da = A2(Gt, "currentTarget", (Lu = qa(A2(La, 0, Sa)), A2(Gt, "parentElement", Lu))), Ra = F3(function(n, r, t) {
        var e = t.ez.d3, u = e.em, a = e.bj;
        return A2(Na, d($([
            Vu("btn btn-link"),
            A2(Ba, "click", A4(_a, n, r, Da, t))
        ]), a), u);
    }), za = F3(function(n, r, t) {
        var e = t.ez;
        return A2(e.di, d(e.bj, $([
            Vu("card-header")
        ])), d(e.bp, d($([
            A3(Ra, n, r, t)
        ]), e.bo)));
    }), Pa = F3(function(n, r, t) {
        var e, u, a, i;
        return A2(aa, d((i = A3(Cr, pa, ga, t.bT), d($([
            Vu("card")
        ]), d((a = i.T).$ ? v : $(a.a.$ ? [
            A2(ea, "border", a.a.a)
        ] : [
            A2(ea, "bg", a.a.a)
        ]), d((u = i.Z).$ ? v : $([
            ua(u.a)
        ]), d((e = i.R).$ ? v : $([
            ta(e.a)
        ]), i.bj))))), $([
            Vu("card")
        ])), $([
            A3(za, n, r, t),
            A3(Ta, n, r, t)
        ]));
    }), Fa = F2(function(n, r) {
        var t = r;
        return A2(aa, v, A2(St, A2(Pa, n, t), t.bm));
    }), Ma = function(n) {
        return A2(Yr, 2.718281828459045, n + 1) / 10;
    }, Ua = xn("li"), Za = F2(function(n, r) {
        return {
            em: r,
            du: Ua,
            bT: n
        };
    }), Ga = xn("mark"), Ja = function(n) {
        return A2(Cn, "rowspan", Tr(n));
    }, Ia = xn("table"), Ka = xn("td"), Ya = xn("tr"), Wa = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, {
                    t: jr(n.a)
                });
            case 3:
                return b(r, {
                    a9: !0
                });
            case 2:
                return b(r, {
                    bs: !0
                });
            case 1:
                return b(r, {
                    ba: !0
                });
            default:
                return b(r, {
                    bj: d(r.bj, n.a)
                });
        }
    }), Qa = {
        a9: !1,
        ba: !1,
        bj: v,
        bs: !1,
        t: kr
    }, Ha = function(n) {
        return n.b;
    }, Va = function(n) {
        return Vu(A2(Nr, " ", A2(St, ut, A2(ye, Ha, n))));
    }, Xa = H, ni = F2(function(n, r) {
        return A2(_n, n, Xa(r));
    })("disabled"), ri = function(n) {
        var r, t = n.em;
        return A2(n.du, (r = A3(Cr, Wa, Qa, n.bT), d($([
            Va($([
                f("list-group-item", !0),
                f("disabled", r.bs),
                f("active", r.ba),
                f("list-group-item-action", r.a9)
            ]))
        ]), d($([
            ni(r.bs)
        ]), d(A2(ge, v, A2(na, function(n) {
            return $([
                A2(ea, "list-group-item", n)
            ]);
        }, r.t)), r.bj)))), t);
    }, ti = xn("ul"), ei = F5(function(n, r, t, e, u) {
        var a, i, o, c, f;
        return A2(aa, v, $([
            A2(Ia, $([
                Vu("table")
            ]), $([
                A2(Ya, v, $([
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha("(")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center lead")
                    ]), $([
                        ha(ma(n.ed))
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha("x")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center lead")
                    ]), $([
                        ha(ma(r.en))
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha(")")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha("+")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha("(")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center lead")
                    ]), $([
                        ha(ma(n.ed))
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha("x")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center lead")
                    ]), $([
                        ha((i = Ma(t), c = ma(100 * i), f = (o = se(A2(jt, ".", c))).$ ? mt(c) : o.a + 3, A3(yt, 0, f, c) + "%"))
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center align-middle display-4"),
                        Ja(2)
                    ]), $([
                        ha(")")
                    ]))
                ])),
                A2(Ya, v, $([
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center text-muted")
                    ]), $([
                        ha("(base salary)")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center text-muted")
                    ]), $([
                        ha("(compressed cost of living)")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center text-muted")
                    ]), $([
                        ha("(base salary)")
                    ])),
                    A2(Ka, $([
                        Vu("border-0 p-0 text-center text-muted")
                    ]), $([
                        ha("(commitment bonus)")
                    ]))
                ]))
            ])),
            (a = $([
                A2(Za, v, $([
                    A2(da, $([
                        Vu("font-weight-bold")
                    ]), $([
                        ha("Base Salary: ")
                    ])),
                    ha("US median for "),
                    A2(Ga, v, $([
                        ha(n.dB)
                    ])),
                    ha(" on Salary.com, divided by 12 (months) and converted to EUR using a 10-year USD -> EUR average. "),
                    ha("This value was fetched from Salary.com on "),
                    A2(Ga, v, $([
                        ha(e)
                    ])),
                    ha(".")
                ])),
                A2(Za, v, $([
                    A2(da, $([
                        Vu("font-weight-bold")
                    ]), $([
                        ha("Compressed Cost of Living: ")
                    ])),
                    ha("Numbeo Cost of Living in "),
                    A2(Ga, v, $([
                        ha(r.dB)
                    ])),
                    ha(" compared to United States, compressed against our Affordability Ratio of 0.49. "),
                    ha("This value was fetched from Numbeo on "),
                    A2(Ga, v, $([
                        ha(u)
                    ])),
                    ha(".")
                ])),
                A2(Za, v, $([
                    A2(da, $([
                        Vu("font-weight-bold")
                    ]), $([
                        ha("Commitment Bonus: ")
                    ])),
                    ha("Natural logarithm of "),
                    A2(Ga, v, $([
                        ha(Tr(t))
                    ])),
                    ha(" years of your tenure, divided by 10.")
                ])),
                A2(Za, v, $([
                    A2(da, $([
                        Vu("font-weight-bold")
                    ]), $([
                        ha("Affordability Ratio: ")
                    ])),
                    ha("The value is set somewhat arbitrarily, to match our salaries before the introduction of Salary System v2.0. The value in v1.0 was set to reflect the average cost of living in 4 major European tech hubs. We adjust the Affordability Ratio every January, based on the previous year's performance.")
                ]))
            ]), A2(ti, $([
                Vu("list-group")
            ]), A2(St, ri, a)))
        ]));
    }), ui = function(n) {
        return {
            $: 11,
            a: n
        };
    }, ai = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ii = function(n) {
        return {
            $: 4,
            a: n
        };
    }, oi = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ci = function(n) {
        return {
            $: 8,
            a: n
        };
    }, fi = function(n) {
        return {
            $: 3,
            a: n
        };
    }, si = function(n) {
        return {
            $: 12,
            a: n
        };
    }, bi = function(n) {
        return {
            $: 9,
            a: n
        };
    }, di = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vi = Hu("type"), li = F2(function(n, r) {
        return A2(Na, d($([
            vi("button"),
            Vu("dropdown-item")
        ]), n), r);
    }), hi = A2(aa, $([
        Vu("dropdown-divider")
    ]), v), $i = F2(function(n, r) {
        return d($([
            Va($([
                f("btn-group", !0),
                f("show", 2 !== n),
                f("dropup", r.aS)
            ]))
        ]), d(A2(ge, v, A2(na, function(n) {
            return $([
                Vu("drop" + (n ? "right" : "left"))
            ]);
        }, r.aN)), r.bj));
    }), pi = F2(function(n, r) {
        var t = n.aW, e = n.cj, u = function(n) {
            return ma(n) + "px";
        }, a = F3(function(n, r, t) {
            return "translate3d(" + u(n) + "," + u(r) + "," + u(t) + ")";
        }), i = $([
            A2(wa, "top", "0"),
            A2(wa, "left", "0")
        ]), o = f(r.aS, r.aN);
        n: for(;;){
            if (o.b.$) {
                if (o.a) break n;
                return d(i, $([
                    A2(wa, "transform", A3(a, -e.aG, e.av, 0))
                ]));
            }
            if (1 === o.b.a) {
                if (o.a) break n;
                return i;
            }
            if (o.a) break n;
            return d(i, $([
                A2(wa, "transform", A3(a, -e.aG - t.aG, 0, 0))
            ]));
        }
        return d(i, $([
            A2(wa, "transform", A3(a, -e.aG, -t.av, 0))
        ]));
    }), gi = F3(function(n, r, t) {
        var e = $(2 === n.D ? [
            A2(wa, "height", "0"),
            A2(wa, "overflow", "hidden"),
            A2(wa, "position", "relative")
        ] : [
            A2(wa, "position", "relative")
        ]);
        return A2(aa, e, $([
            A2(aa, d($([
                Va($([
                    f("dropdown-menu", !0),
                    f("dropdown-menu-right", r.bB),
                    f("show", !0)
                ]))
            ]), d(A2(pi, n, r), r.bH)), A2(St, function(n) {
                return n;
            }, t))
        ]));
    }), mi = F2(function(n, r) {
        switch(n.$){
            case 1:
                return b(r, {
                    bB: !0
                });
            case 0:
                return b(r, {
                    aS: !0
                });
            case 4:
                return b(r, {
                    bj: n.a
                });
            case 2:
                return b(r, {
                    aN: jr(n.a)
                });
            default:
                return b(r, {
                    bH: n.a
                });
        }
    }), yi = {
        bj: v,
        aN: kr,
        bB: !1,
        aS: !1,
        bH: v
    }, wi = F2(function(n, r) {
        var t = n.D, e = r.cL, u = r.c3, a = r.c4, i = A3(Cr, mi, yi, r.bT), o = u;
        return A2(aa, A2($i, t, i), $([
            A2(o, a, n),
            A3(gi, n, i, e)
        ]));
    }), ji = xn("h6"), ki = function(n) {
        return 1 > n ? "Just started" : 1 === n ? Tr(n) + " year" : Tr(n) + " years";
    }, Ai = xn("input"), xi = F2(function(n, r) {
        return A2(Ca, n, {
            $: 0,
            a: r
        });
    }), Ti = function(n) {
        return A2(xi, "click", vt(n));
    }, Ni = function(n) {
        return f(n, !0);
    }, Ei = F2(function(n, r) {
        return A2(Ca, n, {
            $: 1,
            a: r
        });
    }), _i = A2(Oa, $([
        "target",
        "value"
    ]), ne), Ci = function(n) {
        return A2(Ei, "input", A2(bt, Ni, A2(bt, n, _i)));
    }, Bi = A2(Gt, "key", ne), Oi = function(n) {
        return A2(xi, "keydown", A2(bt, n, Bi));
    }, Li = {
        $: 1,
        a: {
            $: 1,
            a: 0
        }
    }, qi = F2(function(n, r) {
        return f(n, r);
    }), Si = Hu("placeholder"), Di = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(sr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Ri = F2(function(n, r) {
        return Fr(A3(Di, n, r, v));
    }), zi = F3(function(n, r, t) {
        if (r > 0) {
            var e = f(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return $([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return $([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, c = o.b, s = c.b, b = s.b, d = b.b;
                                return A2(sr, o.a, A2(sr, c.a, A2(sr, s.a, A2(sr, b.a, n > 1e3 ? A2(Ri, r - 4, d) : A3(zi, n + 1, r - 4, d)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return $([
                e.b.a
            ]);
        }
        return v;
    }), Pi = F2(function(n, r) {
        return A3(zi, 0, n, r);
    }), Fi = F2(function(n, r) {
        return r.$ ? kr : n(r.a);
    }), Mi = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(r, {
                    aj: jr(n.a)
                });
            case 1:
                return b(r, {
                    T: jr(n.a)
                });
            case 2:
                return b(r, {
                    bl: !0
                });
            case 3:
                return b(r, {
                    bs: n.a
                });
            default:
                return b(r, {
                    bj: d(r.bj, n.a)
                });
        }
    }), Ui = {
        bj: v,
        bl: !1,
        T: kr,
        bs: !1,
        aj: kr
    }, Zi = function(n) {
        switch(n){
            case 0:
                return "primary";
            case 1:
                return "secondary";
            case 2:
                return "success";
            case 3:
                return "info";
            case 4:
                return "warning";
            case 5:
                return "danger";
            case 6:
                return "dark";
            case 7:
                return "light";
            default:
                return "link";
        }
    }, Gi = function(n) {
        switch(n){
            case 0:
            case 1:
                return 2;
            default:
                return 0;
        }
    }, Ji = F, Ii = A2(Gt, "offsetWidth", ee), Ki = A2(Gt, "offsetLeft", ee), Yi = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Wi = F2(function(n, r) {
        var t;
        return Yi($([
            A2(Gt, "offsetParent", (t = n, {
                $: 5,
                c: t
            })),
            A2(Gt, "offsetParent", r)
        ]));
    }), Qi = A2(Gt, "offsetTop", ee), Hi = A2(Gt, "scrollLeft", ee), Vi = A2(Gt, "scrollTop", ee), Xi = F2(function(n, r) {
        return A2(st, function(n) {
            var r = n.a, t = n.b;
            return A2(Wi, f(r, t), A2(Xi, r, t));
        }, A5(ae, F4(function(t, e, u, a) {
            return f(n + u - t, r + a - e);
        }), Hi, Vi, Ki, Qi));
    }), no = A4(Ji, F3(function(n, r, t) {
        return {
            av: t,
            ag: n.a,
            ak: n.b,
            aG: r
        };
    }), A2(Xi, 0, 0), Ii, Sa), ro = A2(Oa, $([
        "className"
    ]), ne), to = A2(st, function(n) {
        return vt(!!A2(gt, "dropdown-toggle", n));
    }, ro), eo = F2(function(n, r) {
        return Yi($([
            A2(st, function(t) {
                return t ? A2(Oa, n, r) : Ht("");
            }, A2(Oa, n, to)),
            A2(st, function() {
                return A2(eo, d(n, $([
                    "parentElement"
                ])), r);
            }, A2(Oa, d(n, $([
                "parentElement"
            ])), ro)),
            Ht("No toggler found")
        ]));
    }), uo = A3(dt, qi, A2(eo, $([
        "target"
    ]), no), A2(eo, $([
        "target"
    ]), qa(A2(La, 0, no)))), ao = F2(function(n, r) {
        var t = r.D;
        return A2(st, function(r) {
            var e = r.a;
            return vt(n({
                aW: r.b,
                D: Gi(t),
                cj: e
            }));
        }, uo);
    }), io = F4(function(n, r, t, e) {
        var u, a, i;
        return A2(Na, d((i = A3(Cr, Mi, Ui, n), d($([
            Va($([
                f("btn", !0),
                f("btn-block", i.bl),
                f("disabled", i.bs)
            ])),
            ni(i.bs)
        ]), d((a = A2(Fi, ra, i.aj)).$ ? v : $([
            Vu("btn-" + a.a)
        ]), d((u = i.T).$ ? v : $(u.a.$ ? [
            Vu("btn-outline-" + Zi(u.a.a))
        ] : [
            Vu("btn-" + Zi(u.a.a))
        ]), i.bj)))), $([
            Vu("dropdown-toggle"),
            vi("button"),
            A2(xi, "click", A2(ao, t, e))
        ])), r);
    }), oo = F2(function(n, r) {
        return A2(io, n, r);
    }), co = Hu("value"), fo = y, so = F3(function(n, r, t) {
        return fo(n.ed * r.en + n.ed * Ma(t));
    }), bo = F3(function(n, r, t) {
        var e = f(n, r);
        if (1 === e.a.$) return ha(1 === e.b.$ ? "Please select a role and a country." : "Please select a role.");
        if (1 === e.b.$) return ha("Please select a country.");
        var u = e.a.a, a = e.b.a;
        return A2(da, v, $([
            ha("My monthly gross salary is "),
            A2(da, $([
                Vu("font-weight-bold"),
                Aa("total-salary")
            ]), $([
                ha(Tr(A3(so, u, a, t)) + " €")
            ])),
            ha(".")
        ]));
    }), vo = function(n) {
        var r, t, e, u = F2(function(r, t) {
            var e = a(r, n.P) ? $([
                Ti(di(t)),
                Vu("active")
            ]) : $([
                Ti(di(t))
            ]);
            return A2(li, e, $([
                ha(ki(t))
            ]));
        }), i = F2(function(r, t) {
            var e = a(r, n.M) ? $([
                Ti(fi(t)),
                Vu("active")
            ]) : $([
                Ti(fi(t))
            ]);
            return A2(li, e, $([
                ha(t.dB)
            ]));
        }), o = F2(function(r, t) {
            var e = a(r, n.K) ? $([
                Ti(ii(t)),
                Vu("active")
            ]) : $([
                Ti(ii(t))
            ]);
            return A2(li, e, $([
                ha(t.dB)
            ]));
        });
        return $([
            A2(va, $([
                Vu("lead")
            ]), $([
                ha("I'm a "),
                A2(wi, n.Y, {
                    cL: (t = A2(aa, $([
                        Vu("px-3 py-2"),
                        A2(Ei, "click", vt(f(Fu, !0)))
                    ]), $([
                        A2(Ai, $([
                            Aa("role-search-input"),
                            Si("Search roles..."),
                            co(n.C),
                            Ci(ci),
                            Oi(oi),
                            Vu("form-control form-control-sm")
                        ]), v)
                    ])), e = function() {
                        if (kt(n.C)) {
                            var r = Yt(A2(St, function(n) {
                                return n.e5;
                            }, n.ei)), t = A2(Sr, qi, r), e = F2(function(n, r) {
                                if (r.b) {
                                    var u = r.a.dB, a = r.b, o = Br(r.a.e5), c = A2(St, function(n) {
                                        return A2(i, n.a, n.b);
                                    }, A2(Pi, o, A2(Gu, n, t)));
                                    return A2(sr, (f = $([
                                        ha(u + " Career")
                                    ]), A2(ji, $([
                                        Vu("dropdown-header")
                                    ]), f)), d(c, A2(e, n + o, a)));
                                }
                                var f;
                                return v;
                            });
                            return A2(e, 0, n.ei);
                        }
                        return r = Yt(A2(St, function(n) {
                            return n.e5;
                        }, n.ei)), A2(Sr, i, A2(ye, function(r) {
                            return A2(gt, Iu(n.C), Iu(r.dB));
                        }, r));
                    }(), A2(sr, t, A2(sr, hi, e))),
                    bT: v,
                    c3: A2(oo, $([
                        Li
                    ]), $([
                        ha(A2(ge, "select a role", A2(na, function(n) {
                            return n.dB;
                        }, n.t)))
                    ])),
                    c4: He
                }),
                ha(" living in "),
                A2(wi, n.F, {
                    cL: function() {
                        var r = A2(aa, $([
                            Vu("px-3 py-2"),
                            A2(Ei, "click", vt(f(Fu, !0)))
                        ]), $([
                            A2(Ai, $([
                                Aa("country-search-input"),
                                Si("Search countries..."),
                                co(n.z),
                                Ci(ai),
                                Oi(ui),
                                Vu("form-control form-control-sm")
                            ]), v)
                        ])), t = kt(n.z) ? n.ep : A2(ye, function(r) {
                            return A2(gt, Iu(n.z), Iu(r.dB));
                        }, n.ep);
                        return A2(sr, r, A2(sr, hi, A2(Sr, o, t)));
                    }(),
                    bT: v,
                    c3: A2(oo, $([
                        Li
                    ]), $([
                        ha(A2(ge, "select a country", A2(na, function(n) {
                            return n.dB;
                        }, n.q)))
                    ])),
                    c4: Qe
                }),
                ha(" with a tenure at Niteo of "),
                A2(wi, n.O, {
                    cL: function() {
                        var r = A2(aa, $([
                            Vu("px-3 py-2"),
                            A2(Ei, "click", vt(f(Fu, !0)))
                        ]), $([
                            A2(Ai, $([
                                Aa("tenure-search-input"),
                                Si("Search years..."),
                                co(n.E),
                                Ci(bi),
                                Oi(si),
                                Vu("form-control form-control-sm")
                            ]), v)
                        ])), t = $([
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12,
                            15,
                            20
                        ]), e = kt(n.E) ? t : A2(ye, function(r) {
                            return A2(gt, n.E, Tr(r));
                        }, t);
                        return A2(sr, r, A2(sr, hi, A2(Sr, u, e)));
                    }(),
                    bT: v,
                    c3: A2(oo, $([
                        Li
                    ]), $([
                        ha(Tr(n.N))
                    ])),
                    c4: Ve
                }),
                (r = n.N, ha(r && 1 === r ? " year." : " years."))
            ])),
            A2(va, $([
                Vu("lead")
            ]), $([
                A3(bo, n.t, n.q, n.N)
            ]))
        ]);
    }, lo = F2(function(n, r) {
        return b(r, {
            bj: n
        });
    }), ho = F2(function(n, r) {
        return b(r, {
            em: n
        });
    }), $o = {
        bj: v,
        em: v,
        ac: kr,
        t: 1,
        n: 0,
        an: !1
    }, po = F2(function(n, r) {
        return b(r, {
            t: n
        });
    }), go = F2(function(n, r) {
        return A2(Cn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
        }(r));
    }), mo = F2(function(n, r) {
        var t = r.ac;
        return t.$ ? v : $([
            A2(F2(function(n, r) {
                return Ti(r(n));
            }), r.an ? 1 : 3, t.a)
        ]);
    }), yo = F2(function(n, r) {
        return r.b ? A2(sr, r.a, A2(sr, n, r.b)) : $([
            n
        ]);
    }), wo = function(n) {
        return !n.ac.$;
    }, jo = F3(function(n, r, t) {
        return wo(r) ? A2(yo, A2(Na, d($([
            vi("button"),
            Vu("close"),
            A2(go, "aria-label", "close")
        ]), A2(mo, n, r)), $([
            A2(da, $([
                A2(go, "aria-hidden", "true")
            ]), $([
                ha("\xd7")
            ]))
        ])), t) : t;
    }), ko = F2(function(n, r) {
        var t = 3 === n ? $([
            A2(wa, "display", "none")
        ]) : v, e = function() {
            if (r.an) {
                var n = r.ac;
                return n.$ ? v : $([
                    A2(xi, "transitionend", vt((0, n.a)(3)))
                ]);
            }
            return v;
        }(), u = $([
            A2(go, "role", "alert"),
            Va($([
                f("alert", !0),
                f("alert-dismissible", wo(r)),
                f("fade", r.an),
                f("show", !n)
            ])),
            A2(ea, "alert", r.t)
        ]);
        return Yt($([
            r.bj,
            u,
            t,
            e
        ]));
    }), Ao = F2(function(n, r) {
        var t = r;
        return A2(aa, A2(ko, n, t), A3(jo, n, t, t.em));
    }), xo = F3(function(n, r, t) {
        return A2(Ao, 0, A2(ho, t, A2(lo, r, A2(po, n, $o))));
    })(4), To = function(n) {
        return $([
            n
        ]);
    }, No = function(n) {
        return b(n, {
            an: !0
        });
    };
    qu = {
        Main: {
            init: Zt({
                eG: function(n) {
                    return f(function() {
                        var r = A2(oe, ie, n.cA);
                        if (1 === r.$) return {
                            ao: ve,
                            ei: v,
                            ej: "1970-01-01",
                            ep: v,
                            eq: "1970-01-01",
                            q: kr,
                            F: he,
                            z: "",
                            K: 0,
                            bt: jr(Ur(r.a)),
                            t: kr,
                            Y: he,
                            C: "",
                            M: 0,
                            N: 0,
                            O: he,
                            E: "",
                            P: 0,
                            y: v
                        };
                        var t, e = r.a, u = Yt(A2(St, function(n) {
                            return n.e5;
                        }, e.ei)), a = A4(ke, Jt, Ie("role"), Ie("country"), A2(me, "years", function(n) {
                            return n.b && !n.b.b ? xt(n.a) : kr;
                        })), i = A2(Je, Ke, a), o = A2(Ct, "http://", t = n.cM) ? A2(_t, 0, A2(wt, 7, t)) : A2(Ct, "https://", t) ? A2(_t, 1, A2(wt, 8, t)) : kr, c = o.$ ? {
                            q: kr,
                            t: kr,
                            cw: kr
                        } : A2(ge, {
                            q: kr,
                            t: kr,
                            cw: kr
                        }, A2(Ue, i, b(o.a, {
                            e$: "/"
                        }))), f = function() {
                            var n = c.t;
                            if (n.$) return yr(se(u));
                            var r = n.a;
                            return A2(je, jr, A2(fe, A2(It, "Invalid role provided via URL: " + r + ". Please choose one from the dropdown below.", 0), A2(we, r, u)));
                        }(), s = function() {
                            var n = c.q;
                            if (n.$) return yr(se(e.ep));
                            var r = n.a;
                            return A2(je, jr, A2(fe, A2(It, "Invalid country provided via URL: " + r + ". Please choose one from the dropdown below.", 1), A2(we, r, e.ep)));
                        }(), d = Ye($([
                            f.$ ? jr(f.a) : kr,
                            s.$ ? jr(s.a) : kr
                        ]));
                        return {
                            ao: ve,
                            ei: e.ei,
                            ej: e.ej,
                            ep: e.ep,
                            eq: e.eq,
                            q: A2(ce, function() {
                                return kr;
                            }, s),
                            F: he,
                            z: "",
                            K: 0,
                            bt: kr,
                            t: A2(ce, function() {
                                return kr;
                            }, f),
                            Y: he,
                            C: "",
                            M: 0,
                            N: A2(ge, 2, c.cw),
                            O: he,
                            E: "",
                            P: 0,
                            y: d
                        };
                    }(), Ae);
                },
                e8: function(n) {
                    return Xe($([
                        A2(Pu, n.Y, He),
                        A2(Pu, n.F, Qe),
                        A2(Pu, n.O, Ve),
                        A2(gu, n.ao, We)
                    ]));
                },
                fd: Ku,
                fe: function(n) {
                    var r, t, e, u, i = n.bt;
                    return i.$ ? A2(aa, v, $([
                        (u = n.y, A2(aa, v, A2(St, xo(v), A2(St, To, A2(St, ha, A2(St, function(n) {
                            return n.dA;
                        }, u)))))),
                        A2(Fa, n.ao, A2(ca, $([
                            (e = {
                                ee: (t = f(n.t, n.q), 1 === t.a.$ || 1 === t.b.$ ? v : $([
                                    A2(oa, v, $([
                                        A2(la, v, $([
                                            A5(ei, t.a.a, t.b.a, n.N, n.ej, n.eq)
                                        ]))
                                    ]))
                                ])),
                                ez: A2(ba, vo(n), A2(fa, v, A2($a, $([
                                    Vu("p-0")
                                ]), $([
                                    A2(da, v, $([
                                        a(n.t, kr) || a(n.q, kr) ? ha("") : ha("Okay, let's break that down ...")
                                    ]))
                                ])))),
                                eD: "card1",
                                bT: $([
                                    sa
                                ])
                            }, {
                                ee: e.ee,
                                ez: e.ez,
                                eD: e.eD,
                                bT: e.bT
                            })
                        ]), No((r = We, {
                            bm: v,
                            aZ: !1,
                            c2: r,
                            an: !1
                        }))))
                    ])) : ha("App initialization failed: " + i.a);
                }
            })(A2(st, function(n) {
                return A2(st, function(r) {
                    return vt({
                        cA: r,
                        cM: n
                    });
                }, A2(Gt, "config", Yu));
            }, A2(Gt, "location", ne)))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, qu) : n.Elm = qu;
}($c4926bcb88dfb64a$exports);


var $53834bdc4e950c27$exports = {};
$53834bdc4e950c27$exports = {
    "eur_to_usd_10_year_avg": 1.182208,
    "careers_updated": "2026-01-10",
    "careers": [
        {
            "name": "Design",
            "roles": [
                {
                    "name": "Junior Designer",
                    "baseSalary": 5050,
                    "salary_com_key": "web-designer-i"
                },
                {
                    "name": "Designer",
                    "baseSalary": 5790,
                    "salary_com_key": "web-designer-ii"
                },
                {
                    "name": "Senior Designer",
                    "baseSalary": 7095,
                    "salary_com_key": "web-designer-iii"
                },
                {
                    "name": "Lead Designer",
                    "baseSalary": 9558,
                    "salary_com_key": "web-designer-iv"
                },
                {
                    "name": "Principal Designer",
                    "baseSalary": 10685,
                    "salary_com_key": "art-director"
                }
            ]
        },
        {
            "name": "Marketing",
            "roles": [
                {
                    "name": "Junior Digital Marketer",
                    "baseSalary": 4235,
                    "salary_com_key": "digital-marketing-analyst-i"
                },
                {
                    "name": "Digital Marketer",
                    "baseSalary": 4981,
                    "salary_com_key": "digital-marketing-analyst-ii"
                },
                {
                    "name": "Senior Digital Marketer",
                    "baseSalary": 7145,
                    "salary_com_key": "digital-marketing-analyst-iii"
                },
                {
                    "name": "Lead Digital Marketer",
                    "baseSalary": 8126,
                    "salary_com_key": "digital-marketing-manager"
                },
                {
                    "name": "Principal Digital Marketer",
                    "baseSalary": 14336,
                    "salary_com_key": "digital-marketing-director"
                }
            ]
        },
        {
            "name": "Operations",
            "roles": [
                {
                    "name": "Customer Support",
                    "baseSalary": 3519,
                    "salary_com_key": "customer-support-specialist"
                },
                {
                    "name": "Technical Support",
                    "baseSalary": 4442,
                    "salary_com_key": "technical-customer-support-specialist-i"
                },
                {
                    "name": "Support Manager",
                    "baseSalary": 5833,
                    "salary_com_key": "it-project-manager-i"
                },
                {
                    "name": "Project Manager",
                    "baseSalary": 6970,
                    "salary_com_key": "it-project-manager-ii"
                },
                {
                    "name": "Operations Manager",
                    "baseSalary": 8506,
                    "salary_com_key": "it-project-manager-iii"
                }
            ]
        },
        {
            "name": "Technical",
            "roles": [
                {
                    "name": "Junior Software Engineer",
                    "baseSalary": 5756,
                    "salary_com_key": "software-engineer-i"
                },
                {
                    "name": "Software Engineer",
                    "baseSalary": 7407,
                    "salary_com_key": "software-engineer-ii"
                },
                {
                    "name": "Senior Software Engineer",
                    "baseSalary": 9072,
                    "salary_com_key": "software-engineer-iii"
                },
                {
                    "name": "Lead Software Engineer",
                    "baseSalary": 10497,
                    "salary_com_key": "software-engineer-iv"
                },
                {
                    "name": "Principal Software Engineer",
                    "baseSalary": 12065,
                    "salary_com_key": "software-engineer-v"
                },
                {
                    "name": "Information Technology Director",
                    "baseSalary": 14437,
                    "salary_com_key": "information-technology-director"
                }
            ]
        }
    ],
    "affordability": 0.35,
    "countries_updated": "2026-01-10",
    "countries": [
        {
            "name": "Albania",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Algeria",
            "cost_of_living": 0.3,
            "compressed_cost_of_living": 0.33
        },
        {
            "name": "Argentina",
            "cost_of_living": 0.5,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Armenia",
            "cost_of_living": 0.52,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Australia",
            "cost_of_living": 0.95,
            "compressed_cost_of_living": 0.55
        },
        {
            "name": "Austria",
            "cost_of_living": 0.9,
            "compressed_cost_of_living": 0.53
        },
        {
            "name": "Bangladesh",
            "cost_of_living": 0.25,
            "compressed_cost_of_living": 0.32
        },
        {
            "name": "Belarus",
            "cost_of_living": 0.39,
            "compressed_cost_of_living": 0.36
        },
        {
            "name": "Belgium",
            "cost_of_living": 0.86,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Bolivia",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "Bosnia And Herzegovina",
            "cost_of_living": 0.44,
            "compressed_cost_of_living": 0.38
        },
        {
            "name": "Brazil",
            "cost_of_living": 0.38,
            "compressed_cost_of_living": 0.36
        },
        {
            "name": "Bulgaria",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Cambodia",
            "cost_of_living": 0.43,
            "compressed_cost_of_living": 0.38
        },
        {
            "name": "Canada",
            "cost_of_living": 0.86,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Chile",
            "cost_of_living": 0.48,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "Colombia",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Costa Rica",
            "cost_of_living": 0.69,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Croatia",
            "cost_of_living": 0.66,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Cyprus",
            "cost_of_living": 0.79,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Czech Republic",
            "cost_of_living": 0.68,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Denmark",
            "cost_of_living": 1,
            "compressed_cost_of_living": 0.56
        },
        {
            "name": "Dominican Republic",
            "cost_of_living": 0.5,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Ecuador",
            "cost_of_living": 0.37,
            "compressed_cost_of_living": 0.36
        },
        {
            "name": "Egypt",
            "cost_of_living": 0.25,
            "compressed_cost_of_living": 0.32
        },
        {
            "name": "El Salvador",
            "cost_of_living": 0.52,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Estonia",
            "cost_of_living": 0.72,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "Ethiopia",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Finland",
            "cost_of_living": 0.85,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "France",
            "cost_of_living": 0.84,
            "compressed_cost_of_living": 0.51
        },
        {
            "name": "Georgia",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Germany",
            "cost_of_living": 0.87,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Ghana",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Greece",
            "cost_of_living": 0.64,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Guatemala",
            "cost_of_living": 0.59,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Honduras",
            "cost_of_living": 0.46,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "Hungary",
            "cost_of_living": 0.57,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Iceland",
            "cost_of_living": 1.35,
            "compressed_cost_of_living": 0.68
        },
        {
            "name": "India",
            "cost_of_living": 0.22,
            "compressed_cost_of_living": 0.31
        },
        {
            "name": "Indonesia",
            "cost_of_living": 0.33,
            "compressed_cost_of_living": 0.34
        },
        {
            "name": "Ireland",
            "cost_of_living": 1.04,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Israel",
            "cost_of_living": 1.05,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Italy",
            "cost_of_living": 0.76,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Japan",
            "cost_of_living": 0.58,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Jordan",
            "cost_of_living": 0.45,
            "compressed_cost_of_living": 0.38
        },
        {
            "name": "Kenya",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "Kuwait",
            "cost_of_living": 0.6,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Latvia",
            "cost_of_living": 0.61,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Lebanon",
            "cost_of_living": 0.53,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Libya",
            "cost_of_living": 0.22,
            "compressed_cost_of_living": 0.31
        },
        {
            "name": "Lithuania",
            "cost_of_living": 0.62,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Luxembourg",
            "cost_of_living": 1.17,
            "compressed_cost_of_living": 0.62
        },
        {
            "name": "Malaysia",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Malta",
            "cost_of_living": 0.78,
            "compressed_cost_of_living": 0.49
        },
        {
            "name": "Mexico",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Moldova",
            "cost_of_living": 0.48,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "Montenegro",
            "cost_of_living": 0.55,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Morocco",
            "cost_of_living": 0.37,
            "compressed_cost_of_living": 0.36
        },
        {
            "name": "Namibia",
            "cost_of_living": 0.47,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "Nepal",
            "cost_of_living": 0.25,
            "compressed_cost_of_living": 0.32
        },
        {
            "name": "Netherlands",
            "cost_of_living": 1.03,
            "compressed_cost_of_living": 0.57
        },
        {
            "name": "New Zealand",
            "cost_of_living": 0.8,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Nicaragua",
            "cost_of_living": 0.4,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Nigeria",
            "cost_of_living": 0.46,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "North Macedonia",
            "cost_of_living": 0.41,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Norway",
            "cost_of_living": 1.06,
            "compressed_cost_of_living": 0.58
        },
        {
            "name": "Oman",
            "cost_of_living": 0.54,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Pakistan",
            "cost_of_living": 0.22,
            "compressed_cost_of_living": 0.31
        },
        {
            "name": "Palestine",
            "cost_of_living": 0.56,
            "compressed_cost_of_living": 0.42
        },
        {
            "name": "Panama",
            "cost_of_living": 0.64,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Paraguay",
            "cost_of_living": 0.36,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "Peru",
            "cost_of_living": 0.42,
            "compressed_cost_of_living": 0.37
        },
        {
            "name": "Philippines",
            "cost_of_living": 0.36,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "Poland",
            "cost_of_living": 0.61,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Portugal",
            "cost_of_living": 0.67,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Puerto Rico",
            "cost_of_living": 0.8,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Qatar",
            "cost_of_living": 0.81,
            "compressed_cost_of_living": 0.5
        },
        {
            "name": "Romania",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Russia",
            "cost_of_living": 0.45,
            "compressed_cost_of_living": 0.38
        },
        {
            "name": "Rwanda",
            "cost_of_living": 0.35,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "Senegal",
            "cost_of_living": 0.66,
            "compressed_cost_of_living": 0.45
        },
        {
            "name": "Serbia",
            "cost_of_living": 0.52,
            "compressed_cost_of_living": 0.41
        },
        {
            "name": "Singapore",
            "cost_of_living": 1.45,
            "compressed_cost_of_living": 0.71
        },
        {
            "name": "Slovakia",
            "cost_of_living": 0.62,
            "compressed_cost_of_living": 0.44
        },
        {
            "name": "Slovenia",
            "cost_of_living": 0.7,
            "compressed_cost_of_living": 0.47
        },
        {
            "name": "South Africa",
            "cost_of_living": 0.47,
            "compressed_cost_of_living": 0.39
        },
        {
            "name": "South Korea",
            "cost_of_living": 0.73,
            "compressed_cost_of_living": 0.48
        },
        {
            "name": "Spain",
            "cost_of_living": 0.69,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Sri Lanka",
            "cost_of_living": 0.39,
            "compressed_cost_of_living": 0.36
        },
        {
            "name": "Sweden",
            "cost_of_living": 0.86,
            "compressed_cost_of_living": 0.52
        },
        {
            "name": "Switzerland",
            "cost_of_living": 1.49,
            "compressed_cost_of_living": 0.73
        },
        {
            "name": "Syria",
            "cost_of_living": 0.29,
            "compressed_cost_of_living": 0.33
        },
        {
            "name": "Taiwan",
            "cost_of_living": 0.6,
            "compressed_cost_of_living": 0.43
        },
        {
            "name": "Tanzania",
            "cost_of_living": 0.33,
            "compressed_cost_of_living": 0.34
        },
        {
            "name": "Thailand",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Tunisia",
            "cost_of_living": 0.33,
            "compressed_cost_of_living": 0.34
        },
        {
            "name": "Turkey",
            "cost_of_living": 0.49,
            "compressed_cost_of_living": 0.4
        },
        {
            "name": "Ukraine",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.35
        },
        {
            "name": "United Kingdom",
            "cost_of_living": 0.93,
            "compressed_cost_of_living": 0.54
        },
        {
            "name": "United States",
            "cost_of_living": 1,
            "compressed_cost_of_living": 0.56
        },
        {
            "name": "Uruguay",
            "cost_of_living": 0.67,
            "compressed_cost_of_living": 0.46
        },
        {
            "name": "Venezuela",
            "cost_of_living": 0.43,
            "compressed_cost_of_living": 0.38
        },
        {
            "name": "Vietnam",
            "cost_of_living": 0.34,
            "compressed_cost_of_living": 0.35
        }
    ]
};


(0, $c4926bcb88dfb64a$exports.Elm).Main.init({
    flags: {
        location: location.href,
        config: (/*@__PURE__*/$parcel$interopDefault($53834bdc4e950c27$exports))
    },
    node: document.getElementById("app-container")
});



})();
//# sourceMappingURL=salary-calculator.js.map
